import { render, staticRenderFns } from "./PanelIzquierdo.vue?vue&type=template&id=4e937dd6&scoped=true&"
import script from "./PanelIzquierdo.vue?vue&type=script&lang=js&"
export * from "./PanelIzquierdo.vue?vue&type=script&lang=js&"
import style0 from "./PanelIzquierdo.vue?vue&type=style&index=0&id=4e937dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e937dd6",
  null
  
)

export default component.exports